<template>
  <div class="units">
    
    <div class="container-fluid">
      
      <div class="statistcs-container">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="statistic-card">
              <el-statistic :value="formatPrice(units.total_prices)">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    Total Units Prices
                    <el-tooltip
                      effect="dark"
                      content="Number of total units prices "
                      placement="top"
                    >
                      <el-icon style="margin-left: 4px" :size="12">
                        <Warning />
                      </el-icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>than yesterday</span>
                  <span class="green">
                    24%
                    <el-icon>
                      <CaretTop />
                    </el-icon>
                  </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="statistic-card">
              <el-statistic :value="units.total">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    Total Units
                    <el-tooltip
                      effect="dark"
                      content="Number of Total Units"
                      placement="top"
                    >
                      <el-icon style="margin-left: 4px" :size="12">
                        <Warning />
                      </el-icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>month on month</span>
                  <span class="red">
                    12%
                    <el-icon>
                      <CaretBottom />
                    </el-icon>
                  </span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="statistic-card">
              <el-statistic :value="72000" title="New transactions today">
                <template #title>
                  <div style="display: inline-flex; align-items: center">
                    New transactions today
                  </div>
                </template>
              </el-statistic>
              <div class="statistic-footer">
                <div class="footer-item">
                  <span>than yesterday</span>
                  <span class="green">
                    16%
                    <el-icon>
                      <CaretTop />
                    </el-icon>
                  </span>
                </div>
                <div class="footer-item">
                  <el-icon :size="14">
                    <ArrowRight />
                  </el-icon>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      
      <div class="table-main-actions-container">
        <div class="table-actions-container">
          <div class="row">
            <div class="sorting-container col-4">
              <el-button
                      type="info"
                      link
                      @click="refreshUnits"
                    >
                    <font-awesome-icon icon="fa-solid fa-house-chimney"/> <span style="margin-left:5px;"> All Units </span>
                    </el-button>
            </div>
            <div class="col-8 table-actions">
              <ul class="actions-list" v-if="units.data">
                <li><el-button :class="'add-btn danger'" type="danger" @click="openAddForm"><font-awesome-icon icon="fa-solid fa-plus"/> Add New</el-button></li>
                <li v-if="store.getters['auth/getUserType'] == 'Admin'"><el-button :class="'add-btn excel'" @click="exportToExcel" :loading="isExport" type="plain"><font-awesome-icon icon="fa-solid fa-file-export" /> Export</el-button></li>
                <li v-if="store.getters['auth/getUserType'] == 'Admin' || store.getters['auth/getUserType'] == 'Authorize'">
                    <el-button
                      v-if="!isSearch"
                      type="info"
                      link
                      @click="openSearch"
                    >
                    <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Search
                    </el-button>
                    <el-input
                      v-if="isSearch"
                      v-model="searchValue"
                      style="max-width: 300px"
                      placeholder="Please input"
                      class="input-with-select"
                    >
                      <template #append>
                        <el-button style="width: 30px;" @click="searchUnit">
                          <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
                        </el-button>
                      </template>
                    </el-input>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <el-table :row-class-name="tableRowClassName" v-loading="isLoading" element-loading-text="Loading..." element-loading-background="rgba(255, 255, 255, 0.8)" :data="units.data" style="width: 100%" :header-row-class-name="'table-header-style'" :header-cell-class-name="'table-header-cell-style'" :highlight-current-row="true" :cell-class-name="'custom-cell'">
        <el-table-column type="selection" width="55"  fixed="left"/>
        <el-table-column 
          label="ID" 
          prop="id" 
          width="60"
          
        />
        <el-table-column 
          prop="created_at" 
          width="140"
          :formatter="formatDate"
        >
        
        <template #header>
            Time Stamp
            <FilterPopover
              :filterKey="'created_at'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-date-picker
                v-model="filter_model.created_at"
                type="daterange"
                :shortcuts="shortcuts"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                :size="'large'"
                
              />
            </FilterPopover>

          </template>

        </el-table-column>
        <el-table-column 
          prop="updated_at" 
          width="150"
          :formatter="formatDate"

        >

          <template #header>
            Updated at
            <FilterPopover
              :filterKey="'updated_at'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-date-picker
                v-model="filter_model.updated_at"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                :size="'large'"
              />
            </FilterPopover>

          </template>

        </el-table-column>
        
        <el-table-column 
          label="User" 
          width="160"
        >
        <template #default="scope">
          <div style="display: flex; line-height: 10px; cursor: pointer;">
            <el-avatar
              size="small"
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            />
            <div>
              <h5 style="font-size: 12px; margin-bottom: 0;">{{ scope.row.user.first_name }} {{ scope.row.user.last_name }}</h5>
              <span style="font-size: 10px; line-height: unset;">{{ scope.row.user.account_type }}</span>
            </div>
          </div>
          
        </template>

        </el-table-column>

        <el-table-column 
          label="Client name" 
          width="120"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            {{
              scope.row.is_edit_active ? "" : scope.row.clientName
            }}
            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.clientName"

              placeholder="client name"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column 
          label="Client number" 
          width="200"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <el-button v-if="!scope.row.is_edit_active" text  circle @click="openWhatsApp(scope.row.clientNumber , scope.row)">

              <font-awesome-icon icon="fa-brands fa-square-whatsapp" size="xl" style="color: #008f64;" />
            </el-button>
            <a v-if="!scope.row.is_edit_active"  :href="`tel:${scope.row.clientNumber}`">
              <el-button style="margin-left: 0px;  margin-right: 5px; background-color: #005980;  border: none; border-radius: 2px;  width: 19px; height: 19px;" circle>

                <font-awesome-icon icon="fa-solid fa-phone" size="xs" style="color: #fff;" />
              </el-button>
            </a>
            {{  scope.row.is_edit_active ? "" : scope.row.clientNumber }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.clientNumber"

              placeholder="client number"
              clearable
            />
          </template>
        </el-table-column>
        <!-- Repeat the above pattern for other columns as necessary -->
        <el-table-column label="Name" prop="name" width="150" :show-overflow-tooltip="true" />
        <el-table-column width="140" :show-overflow-tooltip="true" >
          <template #header>
            Developer 
            <FilterPopover
              :filterKey="'developer_id'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                v-model="filter_model.developer_id"
                filterable
                clearable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Choose Developer"
                
              >
                <el-option
                  v-for="type in projectDeveloper"
                  :key="type.id"
                  :label="type.name"
                  :value="type.id"
                />
              </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.developer_name }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.developer_id"
              filterable
              clearable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Developer"
              
            >
              <el-option
                v-for="dev in projectDeveloper"
                :key="dev.id"
                :label="dev.name"
                :value="dev.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="140" :show-overflow-tooltip="true" >
          <template #header>
            Project 
            <FilterPopover
              :filterKey="'project_id'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                v-model="filter_model.project_id"
                filterable
                clearable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Choose Project"
                
              
              >
              <el-option
                v-for="proj in developerProjects"
                :key="proj.id"
                :label="proj.name"
                :value="proj.id"
              />
            </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.project_name }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.project_id"
              filterable
              clearable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Project"
              
            >
              <el-option
                v-for="proj in developerProjects"
                :key="proj.id"
                :label="proj.name"
                :value="proj.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true" >
          <template #header>
            Type 
            <FilterPopover
              :filterKey="'type'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.type"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Type"
                    
                  >
                    <el-option
                      v-for="type in lists.types"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                    />
                  </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.type }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.type"
              filterable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Type"
              
            >
              <el-option
                v-for="type in lists.types"
                :key="type.id"
                :label="type.name"
                :value="type.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="100" >
          
          <template #header>
            Area 
            <FilterPopover
              :filterKey="'size'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.size"
                type="number"
                placeholder="size"
                clearable
               />
            </FilterPopover>

          </template>
          
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.size }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.size"
              clearable
              type="number"
              placeholder="size "
              
            />
          </template>
        </el-table-column>
        <el-table-column  width="100" >
          <template #header>
            Land 
            <FilterPopover
              :filterKey="'land'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.land"
                type="number"
                placeholder="land"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.land }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.land"
              type="number"
              placeholder="land "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="130" >
          <template #header>
            Bedrooms 
            <FilterPopover
              :filterKey="'bedrooms'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.bedrooms"
                type="number"
                placeholder="beds"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.bedrooms }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.bedrooms"
              type="number"
              placeholder="bedrooms "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="130" >
          <template #header>
            Bathrooms 
            <FilterPopover
              :filterKey="'bathrooms'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.bathrooms"
                type="number"
                placeholder="baths"
                clearable
               />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.bathrooms }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.bathrooms"
              type="number"
              placeholder="bathrooms "
              
            />
          </template>
        </el-table-column>
        <el-table-column width="120" >
          <template #header>
            Floor 
            <FilterPopover
              :filterKey="'level'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.level"
                type="number"
                placeholder="Floor"
                clearable
              />
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.level }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.level"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose Level"
              
            >
              <el-option
                v-for="level in lists.levels"
                :key="level.id"
                :label="level.name"
                :value="level.name"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true"  >
          <template #header>
            Downpayment 
            <FilterPopover
              :filterKey="'down_payment'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.down_payment_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.down_payment_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.down_payment) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.down_payment"
              type="text"
              placeholder="downpayment "
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true">
          <template #header>
            Installments 
            <FilterPopover
              :filterKey="'quarter_installment'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.quarter_installment_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.quarter_installment_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.quarter_installment) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.quarter_installment"
              type="text"
              placeholder="quarter installment "
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="160" :show-overflow-tooltip="true" >
          <template #header>
            Total price 
            <FilterPopover
              :filterKey="'price'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-input
                v-model="filter_model.price_start"
                type="number"
                placeholder="Start"
                clearable
                
              />
              <div class="mt-2">
                <el-input
                  v-model="filter_model.price_end"
                  type="number"
                  placeholder="End"
                  clearable
                  
                />
              </div>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : formatPrice(scope.row.price) }}

            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.price"
              type="text"
              placeholder="price"
              :formatter="formatPrice"
            />
          </template>
        </el-table-column>
        <el-table-column width="150" :show-overflow-tooltip="true">
          <template #header>
            Finishing 
            <FilterPopover
              :filterKey="'finishing'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.finishing"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Finishing"
                    
                  >
                    <el-option
                      v-for="type in lists.finishings"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                    />
                  </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.finishing }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.finishing"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Finishing"
              
            >
              <el-option
                v-for="item in lists.finishings"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="120" :show-overflow-tooltip="true">
          <template #header>
            Location 
            <FilterPopover
              :filterKey="'city'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.city"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose City"
                    
                  >
                    <el-option
                      v-for="type in lists.cities"
                      :key="type.id"
                      :label="type.name"
                      :value="type.name"
                    />
                  </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.city }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.city"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Choose city"
              
            >
              <el-option
                v-for="city in lists.cities"
                :key="city.id"
                :label="city.name"
                :value="city.name"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="150" :show-overflow-tooltip="true">
          <template #header>
            Delivery Date 
            <FilterPopover
              :filterKey="'delivery_date'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.delivery_date"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Date"
                    
                  >
                  <el-option
                    v-for="date in delevery_dates"
                    :key="date.index"
                    :label="date"
                    :value="date"
                  />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.delivery_date }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.delivery_date"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="delivery date"
              
            >
              <el-option
                v-for="date in delevery_dates"
                :key="date.index"
                :label="date"
                :value="date"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column width="120" >
          <template #header>
            Category
            <FilterPopover
              :filterKey="'category'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.category"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose Category"
                    
                  >
                  <el-option
                    v-for="cat in categories"
                    :key="cat.index"
                    :label="cat"
                    :value="cat"
                  />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            {{  scope.row.is_edit_active ? "" : scope.row.category }}
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.category"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="Category"
              
            >
              <el-option
                v-for="cat in categories"
                :key="cat.index"
                :label="cat"
                :value="cat"
              />
            </el-select>
            
          </template>
        </el-table-column>
        <el-table-column   width="120" :show-overflow-tooltip="true">
          <template #header>
            State
            <FilterPopover
              :filterKey="'state'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.state"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose State"
                    
                  >
                  <el-option
                    v-for="state in states"
                    :key="state.index"
                    :label="state"
                    :value="state"
                  />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.state"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="State"
              
            >
              <el-option
                v-for="state in states"
                :key="state.index"
                :label="state"
                :value="state"
              />
            </el-select>
            <el-tag
              v-if="!scope.row.is_edit_active"
              :type="scope.row.state == 'approved' ? 'success' : scope.row.state == 'pending' ? 'warning' : 'danger' "
              effect="light"
            > 
              {{ scope.row.state }}
            </el-tag>
            
          </template>
        </el-table-column>
        <el-table-column width="120" >
          <template #header>
            License
            <FilterPopover
              :filterKey="'license'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
                    v-model="filter_model.license"
                    filterable
                    clearable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Choose License"
                    
                  >
                  <el-option
                    v-for="lic in licenses"
                    :key="lic.index"
                    :label="lic"
                    :value="lic"
                  />
                </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.license"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="license"
              
            >
              <el-option
                v-for="(lic , index) in licenses"
                :key="index"
                :label="lic"
                :value="lic"
              />
            </el-select>
            <el-tag
              v-if="!scope.row.is_edit_active"
              :type="scope.row.license == 'Basic' ? 'primary' : scope.row.license == 'Featured' ? 'success' : 'warning' "
              effect="light"
            > 
              {{ scope.row.license }}
            </el-tag>
            
          </template>
        </el-table-column>
        <el-table-column  width="160">
          <template #header>
            Recommended
            <FilterPopover
              :filterKey="'recommended'"
              :filters="filtersKeys"
              @apply-filter="handleApplyFilter"
              @toggle-popover="handleTogglePopover"
              @cancle-popover="handleCanclePopover"
            >
              <!-- Additional content for the filter -->
              <el-select
              v-model="filter_model.recommended"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="recommended"
              
            >
              <el-option
                v-for="rec in recommended"
                :key="rec.value"
                :label="rec.lable"
                :value="rec.value"
              />
            </el-select>
            </FilterPopover>

          </template>
          <template #default="scope">
            <el-select
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.recommended"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="recommended"
              
            >
              <el-option
                v-for="rec in recommended"
                :key="rec.value"
                :label="rec.lable"
                :value="rec.value"
              />
            </el-select>
            <el-tag
              v-if="!scope.row.is_edit_active"
              :type="scope.row.recommended == 0 ? 'info' : 'primary'"
              effect="light"
              round
            > 
              {{ scope.row.recommended == 0 ? 'Not Recommended' : 'Recommended' }}
            </el-tag>
            
            </template>
        </el-table-column> 
        <el-table-column label="Description"  width="200" :show-overflow-tooltip="false" >
          <template #default="scope">
            <el-popover
              v-if="!scope.row.is_edit_active"
              placement="left-start"
              title="Description"
              :width="250"
              trigger="hover"
              :content="scope.row.description"
            >
              <template #reference>
                {{scope.row.description}}
                
              </template>
            </el-popover>
            <el-input
                  v-if="scope.row.is_edit_active"
                  v-model="Edited_model.description"
                  :rows="1"
                  type="textarea"
                  placeholder="Description"
                />
          </template>
        </el-table-column>
        
        <el-table-column label="Services"  width="200" :show-overflow-tooltip="false" >
          <template #default="scope">
            <el-popover
              v-if="scope.row.services.length != 0"
              placement="left-start"
              title="Services"
              :width="250"
              trigger="hover"
            >
              <template #reference>
                <span v-if="!scope.row.is_edit_active">
                  {{ (scope.row.services.map(serv => serv.name)).join(', ')}}
                </span>
                
              </template>
              <template #default>
                <ul style="list-style: none;">
                  <li v-for="serv in scope.row.services" :key="serv.id">
                    <img :src="'https://tapegypt.com/'+serv.icon" alt="" srcset=""> {{ serv.name }}
                  </li>
                </ul>
              </template>
            </el-popover>
            <el-select
                v-if="scope.row.is_edit_active"
                v-model="Edited_model.services"
                filterable
                multiple 
                collapse-tags
                style="width: 190px;"
                :reserve-keyword="false"
                placeholder="Choose"
                
              >
                <el-option
                  v-for="serv in lists.services"
                  :key="serv.id"
                  :label="serv.name"
                  :value="serv.id"
                >
                  
                </el-option>
              </el-select>
          </template>
        </el-table-column>

        
        <el-table-column label="Notes" width="150" :show-overflow-tooltip="false">
          <template #default="scope">
            <el-popover
              v-if="!scope.row.is_edit_active"
              placement="top-start"
              title="Notes"
              :width="200"
              trigger="hover"
              :content="scope.row.Notes"
            >
              <template #reference>
                {{scope.row.Notes}}
              </template>
            </el-popover>
            <el-input
              v-if="scope.row.is_edit_active"
              v-model="Edited_model.Notes"
              :rows="1"
              type="textarea"
              placeholder="Notes"
            />
          </template>
        </el-table-column>

        <el-table-column label="Offer" width="150" :show-overflow-tooltip="false">
          <template #default="scope">
            <el-image
                v-if="!scope.row.is_edit_active && scope.row.offer_photo"
                style="width: 20px; height: 20px"
                :src="'https://tapegypt.com/offers-photos/'+scope.row.offer_photo"
                :zoom-rate="1.2"
                :max-scale="7"
                :min-scale="0.2"
                
                :initial-index="4"
                fit="cover"
            />
           
            <el-upload
              v-if="!scope.row.offer_photo && scope.row.is_edit_active"
              ref="uploadRef"
              class="upload-demo"
              
              :on-change="AddOfferImage"
            >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            </el-upload>

          </template>
        </el-table-column>

        <!-- Other columns -->
        
        <el-table-column align="center" fixed="right" :width="store.getters['auth/getUserType'] == 'Admin' ? '160' : '120'">
          <template #header>
            Actions
          </template>
          <template #default="scope">
            <el-button
              size="small"
              type="primary"
              :icon="View" 
              circle
              v-if="!scope.row.is_edit_active"
              @click="showUnit(scope.$index)"
            />

            <el-button size="small" @click="openEditForm(scope.$index)" :icon="Edit" 
            circle v-if=" !scope.row.is_edit_active"/>
            
            <!-- Assign Unit To User -->
            <el-popover placement="right" :width="300" trigger="click">
              <template #reference>
                <el-button size="small" type="warning"
                  circle v-if="store.getters['auth/getUserType'] == 'Admin' && !scope.row.is_edit_active" @click="selectedUser = null"
                >
                  <el-icon><Switch /></el-icon>
                </el-button>
                
              </template>
              <el-input v-model="selectedUser" type="number" min="2" placeholder="Assign To" width="300"/>
              <el-button size="small" type="primary" :loading="isAssigning" @click="switchUnitToUser(scope.row.id , selectedUser)">Assign</el-button>

            </el-popover>
            
            
            <el-button
              size="small"
              type="danger"
              :icon="Delete" 
              circle
              @click="deleteUnit(scope.row.id)"
              v-if="!scope.row.is_edit_active"
            />
            <el-button type="success" :icon="Check" circle v-if="scope.row.is_edit_active" @click="EditUnit(scope.$index)"/>
            <el-button type="info" :icon="Close" circle @click="closeEdit(scope.$index)" v-if="scope.row.is_edit_active"/>
            
            
            
          </template>
        </el-table-column>
      
      </el-table>

      <!-- View Unit Drawer-->
      <el-drawer
        v-for="unit , index in units.data"
        :key="unit.id"
        v-model="unit.is_unit_show"
        :title="unit.name"
        :direction="'rtl'"
        :modal-class="'show-modal-drawer'"
        @close="handleUnitClose(index)"
      >
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="img in unit.photos" :key="unit.id+'-image'">
            <img :src="'https://tapegypt.com/'+img" alt="" srcset="">
          </el-carousel-item>
        </el-carousel>

        <h4 style="margin-top: 15px; font-weight: 400; font-size: 18px;"> <span style="font-weight: bold;"> #{{ unit.finishing }} </span> <span style="font-weight: bold;"> #{{ unit.type }} </span> at {{ unit.name }} 
          <el-tag
            :type="unit.license == 'Basic' ? 'primary' : unit.license == 'Featured' ? 'success' : 'warning' "
            effect="light"
            size="medium"
          > 
            {{ unit.license }}
          </el-tag>
        </h4>
        
        
        <ul class="details-list">
          <li>
            <span>
              <font-awesome-icon icon="fa-solid fa-location-dot" style="color: #005980;" />
               {{ unit.city }}
            </span>
          </li>
          <li>
            <span>
              <font-awesome-icon icon="fa-solid fa-bed" style="color: #005980;" />
               {{ unit.bedrooms }} {{ unit.bathrooms > 1 ? 'Beds' : 'Bed' }}
            </span>
          </li>
          <li>
            <span>
              <font-awesome-icon icon="fa-solid fa-bath" style="color: #005980;" />
               {{ unit.bathrooms }} {{ unit.bathrooms > 1 ? 'Bath' : 'Bath' }}
            </span>
          </li>
          <li>
            <span>
              <font-awesome-icon icon="fa-solid fa-turn-up" style="color: #005980;" />
               {{ unit.level }}
            </span>
          </li>
        </ul>

        <div class="user-info-card">
            <div class="user-info">
              <el-avatar shape="square" size="larg" :fit="'cover'" :src="'https://i.sstatic.net/4WkGW.jpg?s=256'" />
              <span class="user-info-span">{{ unit.user.email }} <p>{{unit.user.account_type}}</p></span>
            </div>

        </div>


        <div>
          <h5 style="font-size: 18px;">Description</h5>
          <p style="font-size: 14px;">{{ unit.description }}</p>
        </div>

        <el-descriptions title="Details" :column="2" :size="'large'">
          <el-descriptions-item label="Total Price:">{{formatPrice(unit.price)}}</el-descriptions-item>
          <el-descriptions-item label="Installments:">{{formatPrice(unit.quarter_installment)}}</el-descriptions-item>
          <el-descriptions-item label="Down payment:">{{formatPrice(unit.down_payment)}}</el-descriptions-item>
          <el-descriptions-item label="Delivery:">{{unit.delivery_date}}</el-descriptions-item>
          <el-descriptions-item label="Land:">{{unit.land}}m</el-descriptions-item>
          <el-descriptions-item label="Size:">{{unit.size}}m</el-descriptions-item>
          <el-descriptions-item label="Category:">{{unit.category}}</el-descriptions-item>
          <el-descriptions-item label="Is Recommended">
            <el-tag
              
              :type="unit.recommended == 0 ? 'info' : 'primary'"
              effect="light"
              round
            > 
              {{ unit.recommended == 0 ? 'No' : 'Yes' }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        
      </el-drawer>

      <!-- Add Unit Drawer -->
      <el-drawer
        
        
        v-model="isAdd"
        :title="'Add Unit'"
        :direction="'rtl'"
        :modal-class="'add-modal-drawer'"
        :before-close="handleAddUnitClose"
      >
        <el-form
          ref="ruleFormRef"
          :model="AddUnitForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
        >
        <el-form-item prop="images">
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            multiple
            :auto-upload="false"
            list-type="picture"
            drag
            :on-change="addImageToList"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>

            <template #tip>
              <div class="el-upload__tip">
                jpg/png files with a size less than 500kb
              </div>
            </template>
          </el-upload>
        </el-form-item>
          <el-dialog v-model="dialogVisible">
            <img w-full width="100%"  :src="dialogImageUrl" alt="Preview Image" />
          </el-dialog>

          <h4 style="margin-bottom: 1.5rem; display: flex; margin-top: 15px; font-weight: 400; font-size: 18px;"> 
            <span style="font-weight: bold; display: flex;"> #
              <el-form-item prop="finishing">
                <el-select
                  style="width: 100px"
                  v-model="AddUnitForm.finishing"
                  filterable
                  clearable
                  default-first-option
                  :reserve-keyword="false"
                  placeholder="Finishing"
                  
                >
                  <el-option
                    v-for="item in lists.finishings"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-form-item>
            </span> 
            <span style="font-weight: bold; display: flex;"> #
              <el-form-item prop="type">
                <el-select
                  style="width: 80px"
                  v-model="AddUnitForm.type"
                  filterable
                  clearable
                  allow-create
                  default-first-option
                  :reserve-keyword="false"
                  placeholder="Type"
                  
                >
                  <el-option
                    v-for="type in lists.types"
                    :key="type.id"
                    :label="type.name"
                    :value="type.name"
                  />
                </el-select>
              </el-form-item>
            </span> at

              <el-form-item prop="developer_id">
              <el-select
                style="width: 120px"
                v-model="AddUnitForm.developer_id"
                filterable
                allow-create
                clearable
                default-first-option
                :reserve-keyword="false"
                placeholder="Developer"
                
              >
                <el-option
                  v-for="dev in projectDeveloper"
                  :key="dev.id"
                  :label="dev.name"
                  :value="dev.id"
                />
              </el-select>
            </el-form-item>
            - 
            <el-form-item prop="project_id">
            <el-select
              style="width: 120px ; margin-right: 10px;"
              v-model="AddUnitForm.project_id"
              filterable
              allow-create
              clearable
              default-first-option
              :reserve-keyword="false"
              placeholder="Project"
              
            >
              <el-option
                v-for="proj in developerProjects"
                :key="proj.id"
                :label="proj.name"
                :value="proj.id"
              />
            </el-select> 
          </el-form-item>
            <!-- {{ unit.name }} --> 
            <!-- <el-tag
              type="primary"
              effect="light"
              size="medium"
            > 
              Basic
            </el-tag> -->
          </h4>
          
          
          <ul class="details-list">
            <li>
                <font-awesome-icon icon="fa-solid fa-location-dot" style="color: #005980;" />
                <el-form-item prop="location">
                  <el-select
                    style="width: 100px ; margin-left: 5px;"
                    v-model="AddUnitForm.location"
                    filterable
                    clearable
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Location"
                    
                  >
                    <el-option
                      v-for="city in lists.cities"
                      :key="city.id"
                      :label="city.name"
                      :value="city.name"
                    />
                  </el-select>
              </el-form-item>
                <!-- {{ unit.city }} -->

            </li>
            <li>

                <font-awesome-icon icon="fa-solid fa-bed" style="color: #005980;" />
                <el-form-item prop="bedrooms">
                  <el-input
                    style="width: 80px; margin-left: 5px;"
                    min="0"
                    v-model="AddUnitForm.bedrooms"
                    type="number"
                    placeholder="beds "
                    
                  />
                </el-form-item>
                <!-- {{ unit.bedrooms }} {{ unit.bathrooms > 1 ? 'Beds' : 'Bed' }} -->

            </li>
            <li>
              
                <font-awesome-icon icon="fa-solid fa-bath" style="color: #005980;" />
                <el-form-item prop="bathrooms">
                  <el-input
                    style="width: 80px; margin-left: 5px;"
                    min="0"
                    v-model="AddUnitForm.bathrooms"
                    type="number"
                    placeholder="bath "
                    
                  />
                </el-form-item>
                <!-- {{ unit.bathrooms }} {{ unit.bathrooms > 1 ? 'Bath' : 'Bath' }} -->
              
            </li>
            <li>

                <font-awesome-icon icon="fa-solid fa-turn-up" style="color: #005980;" />
                <el-form-item prop="level">
                <el-select
                  style="width: 80px ; margin-left: 5px;"
                  v-model="AddUnitForm.level"
                  filterable
                  clearable
                  default-first-option
                  :reserve-keyword="false"
                  placeholder="Floor"
                  
                >
                  <el-option
                    v-for="level in lists.levels"
                    :key="level.id"
                    :label="level.name"
                    :value="level.name"
                  />
                </el-select>
              </el-form-item>
                <!-- {{ unit.level }} -->
            </li>
          </ul>

          <div class="user-info-card">
              <div class="user-info">
                <el-avatar shape="square" size="larg" :fit="'cover'" :src="'https://i.sstatic.net/4WkGW.jpg?s=256'" />
                <span class="user-info-span">{{ store.getters['auth/getUserEmail'] }} <p>{{store.getters['auth/getUserType']}}</p></span>
              </div>

          </div>

          <div>
            <h5 style="font-size: 18px;">Description</h5>
            <el-form-item prop="description">
              <el-input
                style="width: 80%; margin: 5px 0px 25px;"
                
                v-model="AddUnitForm.description"
                type="textarea"
                :rows="5"
                
                placeholder="Description "
                
              />
            </el-form-item>
            
            <!-- <p style="font-size: 14px;">{{ unit.description }}</p> -->
          </div>
          <el-descriptions title="Details" :column="2" :size="'large'">
            <el-descriptions-item label="Total Price:">
              <el-form-item prop="price">
              <el-input
                v-model="AddUnitForm.price"
                type="text"
                placeholder="price"
                :formatter="formatPrice"
                style="width: 120px;"
              />
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Installments:">
              <el-form-item prop="quarter_installment">
              <el-input
                v-model="AddUnitForm.quarter_installment"
                type="text"
                placeholder="1,000,000"
                :formatter="formatPrice"
                style="width: 120px;"
              />
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Down payment:">
              <el-form-item prop="down_payment">
              <el-input
                v-model="AddUnitForm.down_payment"
                type="text"
                placeholder="1,000,000"
                :formatter="formatPrice"
                style="width: 120px;"
              />
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Delivery:">
              <el-form-item prop="delivery_date">
              <el-select
                v-model="AddUnitForm.delivery_date"
                filterable
                :reserve-keyword="false"
                placeholder="Choose"
                style="width: 120px;"
              >
                <el-option
                  v-for="date in delevery_dates"
                  :key="date.index"
                  :label="date"
                  :value="date"
                />
              </el-select>
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Land:">
              <el-form-item prop="land">
              <el-input
                v-model="AddUnitForm.land"
                type="number"
                min="0"
                style="width: 120px;"
              />
               m
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Size:">
              <el-form-item prop="size">
                <el-input
                  v-model="AddUnitForm.size"
                  type="number"
                  min="0"
                  style="width: 120px;"
                />
                m
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Category:">
              <el-form-item prop="category">
              <el-select
                v-model="AddUnitForm.category"
                filterable
                :reserve-keyword="false"
                placeholder="Choose"
                style="width: 120px;"
              >
                <el-option
                  v-for="cat in categories"
                  :key="cat.index"
                  :label="cat"
                  :value="cat"
                />
              </el-select>
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Services:">
              <el-form-item prop="services">
              <el-select
                v-model="AddUnitForm.services"
                filterable
                multiple 
                collapse-tags
                style="width: 120px;"
                :reserve-keyword="false"
                placeholder="Choose"
                @change="appendServices"
                
              >
                <el-option
                  v-for="serv in lists.services"
                  :key="serv.id"
                  :label="serv.name"
                  :value="serv.id"
                >
                  
                </el-option>
              </el-select>
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Client Name:">
              <el-form-item prop="clientName">
              <el-input
                v-model="AddUnitForm.clientName"
                type="text"
                style="width: 120px;"
              />
            </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="Client Number:">
              <el-form-item prop="clientNumber">
              <el-input
                v-model="AddUnitForm.clientNumber"
                type="text"
                style="width: 120px;"
              />
            </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          
        </el-form>
          <template #footer>
            <div style="flex: auto">
                <el-button v-loading.fullscreen.lock="isAddFormLoading" @click="handleAddUnitClose">cancel</el-button>
                <el-button type="primary" @click="handleAddSubmit()">Add Unit</el-button>
            </div>
          </template>
      </el-drawer>

      <div class="pagination-container">
        <el-pagination
          :page-size="units.per_page"
          :pager-count="11"
          :size="'small'"
          layout="prev, pager, next"
          :total="units.total"
          :background="true"
          :disabled="isDisabled"
          :current-page="page"
          @current-change="paginationChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import { useStore } from 'vuex';
import numeral from 'numeral';
import dayjs from 'dayjs';
import { VueDraggableNext } from 'vue-draggable-next'
import * as XLSX from 'xlsx';
import {
  ArrowRight,
  CaretBottom,
  CaretTop,
  Check,
  Warning,
  Delete,
  Edit,
  Close,
  View,
} from '@element-plus/icons-vue'

import FilterPopover from '../components/filterPopover.vue';
import { useRouter } from 'vue-router';
import {
  exportUnits as fetchExportUnits,
  fetchAllSearchUnits,
  fetchAllFilteredUnits,
  fetchAllUserUnits,
} from '@/api/units';

export default {
name: 'Units',
components: {
  VueDraggableNext,
  FilterPopover
},
props: {
    userId: {
      type: String,
      required: false,
    },
},
setup(props){
  const ruleFormRef = ref(null);
  const AddUnitForm = reactive({
      bedrooms:0,
      bathrooms:0,
      developer_id: '',
      project_id: '',
      finishing: '',
      services: [],
      size: '',
      land: '',
      location: '',
      city:'',
      type: '',
      category: '',
      description: '',
      price:'',
      name:'',
      down_payment:'',
      quarter_installment:'',
      images:[],
      level:'',
      clientName:'',
      clientNumber:'',
      delivery_date:'',
      license:'Basic',
  });
  const shortcuts = [
      {
        text: 'Today',
        value: () => {
          const today = new Date();

          // Get local time offset in milliseconds
          const timezoneOffset = today.getTimezoneOffset() * 60000;

          // Start of the day (12 AM) local time
          const startOfDay = new Date(today.setHours(0, 0, 0, 0) - timezoneOffset);

          // End of the day (11:59:59.999 PM) local time
          const endOfDay = new Date(today.setHours(23, 59, 59, 999) - timezoneOffset);

          return [startOfDay, endOfDay];
        },
      },
      {
        text: 'Last week',
        value: () => {
          const end = new Date(); // Current date
          const start = new Date(); // Same date as 'end'
          start.setDate(start.getDate() - 7); // Set to 7 days ago (start of last week)

          // Adjust for local timezone (keeping local midnight time)
          const timezoneOffset = start.getTimezoneOffset() * 60000;

          // Adjust both start and end dates based on local timezone offset
          const startOfWeek = new Date(start.setHours(0, 0, 0, 0) - timezoneOffset);
          const endOfWeek = new Date(end.setHours(23, 59, 59, 999) - timezoneOffset);

          return [startOfWeek, endOfWeek];
        },
      },
      {
        text: 'Last month',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 1); // Set to the same date, but one month earlier

          // Adjust for local timezone
          const timezoneOffset = start.getTimezoneOffset() * 60000;
          const startOfMonth = new Date(start.setHours(0, 0, 0, 0) - timezoneOffset);
          const endOfMonth = new Date(end.setHours(23, 59, 59, 999) - timezoneOffset);

          return [startOfMonth, endOfMonth];
        },
      },
      {
        text: 'Last 3 months',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setMonth(start.getMonth() - 3); // Set to the same date, but 3 months earlier

          // Adjust for local timezone
          const timezoneOffset = start.getTimezoneOffset() * 60000;
          const startOf3Months = new Date(start.setHours(0, 0, 0, 0) - timezoneOffset);
          const endOf3Months = new Date(end.setHours(23, 59, 59, 999) - timezoneOffset);

          return [startOf3Months, endOf3Months];
        },
      },
      {
        text: 'Last year',
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setFullYear(start.getFullYear() - 1); // Set to the same date, but one year earlier

          // Adjust for local timezone
          const timezoneOffset = start.getTimezoneOffset() * 60000;
          const startOfYear = new Date(start.setHours(0, 0, 0, 0) - timezoneOffset);
          const endOfYear = new Date(end.setHours(23, 59, 59, 999) - timezoneOffset);

          return [startOfYear, endOfYear];
        },
      },
    ];


  const rules = reactive({
      size: [
        { required: true, message: '@Required', trigger: 'blur' },
        
      ],
      price: [
      { required: true, message: '@Required', trigger: 'blur' },
      ],
      finishing: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
      type: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
      images: [
      { required: true, message: '@Select Unit Images', trigger: 'changed' },
      ],
      level: [
      { required: true, message: '@Required', trigger: 'blur' },
      ],
      bedrooms: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
      bathrooms: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
      location: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
      category: [
      { required: true, message: '@Required', trigger: 'changed' },
      ],
  });
  const filtersKeys = ref({
    state:{
      title:'Filter State' ,
      isFilter:false,
    },
    license:{
      title:'Filter license' ,
      isFilter:false,
    },
    type:{
      title:'Filter Type' ,
      isFilter:false,
    },
    category:{
      title:'Filter Category' ,
      isFilter:false,
    },
    delivery_date:{
      title:'Filter Delivery date' ,
      isFilter:false,
    },
    city:{
      title:'Filter Location' ,
      isFilter:false,
    },
    price:{
      title:'Filter Price' ,
      isFilter:false,
    },
    land:{
      title:'Filter Land' ,
      isFilter:false,
    },
    down_payment:{
      title:'Filter Downpayment' ,
      isFilter:false,
    },
    quarter_installment:{
      title:'Filter Installments' ,
      isFilter:false,
    },
    level:{
      title:'Filter Level' ,
      isFilter:false,
    },
    bedrooms:{
      title:'Filter Beds' ,
      isFilter:false,
    },
    bathrooms:{
      title:'Filter Baths' ,
      isFilter:false,
    },
    size:{
      title:'Filter Size' ,
      isFilter:false,
    },
    finishing:{
      title:'Filter finishing' ,
      isFilter:false,
    },
    developer_id:{
      title:'Filter developer' ,
      isFilter:false,
    },
    project_id:{
      title:'Filter Project' ,
      isFilter:false,
    },
    updated_at:{
      title:'Filter updated at range date' ,
      isFilter:false,
    },
    created_at:{
      title:'Filter Timestamp at range date' ,
      isFilter:false,
    },
    recommended:{
      title:'Filter Recommended' ,
      isFilter:false,
    }
  });
  const userId = ref(props.userId);
  const uploadRef = ref(null);
  const dialogImageUrl = ref('');
  const dialogVisible = ref(false);
  const EditForm = ref(false);
  const isAdd = ref(false);
  const addModel = ref({});
  const units = ref([]);
  const Edited_model = ref({});
  const types = ref([]);
  const lists = ref([]);
  const imagesList = ref([]);
  const isSearch = ref(false);
  const searchValue = ref("");
  const isAddFormLoading = ref(false);
  const delevery_dates = ref([
    'up to 1 year' , 'up to 2 year' ,'up to 3 year' , 'up to 4 year' ,'Ready To Move'
  ])
  const categories = ref([
    'Rent' , 'Resale'
  ]);
  const states = ref([
    'approved','pending' , 'rejected'
  ]);
  const licenses = ref([
    'Basic' , 'Featured' , 'Premuim'
  ]);
  //colorize table row depend on state
  const tableRowClassName = (
  row,
  ) => {


    if (row.row.state == "pending") {
      return 'warning-row'
    }else if(row.row.state == "rejected"){
      return 'danger-row'
    }else if(isLaterThanOneMonth(row.row.updated_at)){
      return 'danger-row'
    }
    else {
        return ''
    }
  }

  function isLaterThanOneMonth(updatedAt) {
    const updatedDate = new Date(updatedAt);
    const now = new Date();

    // إنشاء تاريخ يساوي قبل شهر من الآن
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    return updatedDate < oneMonthAgo;
  }


  const recommended = ref([
    {
      lable:"Recommended",
      value:1
    },
    {
      lable:"Not Recommended",
      value:0
    }
  ]);
  const formSize = ref('default');
  const store = useStore();
  const page = ref();
  const isUnitsFilter = ref(false);
  const isLoading = ref(true);
  const isDisabled = ref(false);
  const isExport = ref(false);
  const message = ref('');
  const router = useRouter();
  const filter_model = reactive({
    bedrooms:null,
    bathrooms:null,
    developer_id: null,
    project_id: null,
    finishing: null,
    services: null,
    size: null,
    land: null,
    location: null,
    city:null,
    type: null,
    category: null,
    description: null,
    price_start:null,
    price_end:null,
    name:null,
    down_payment_start:null,
    down_payment_end:null,
    quarter_installment_start:null,
    quarter_installment_end:null,
    level:null,
    clientName:null,
    clientNumber:null,
    delivery_date:null,
    license:null,
    user_name:null,
    updated_at:null,
    created_at:null,
    created_at_start:null,
    created_at_end:null,
    updated_at_start:null,
    updated_at_end:null,
    recommended:null,
  })
  const isAssigning = ref(false);
  const selectedUser = ref(null);
  const switchUnitToUser = async (unitId , userId) => {
    if (!userId) {
      ElMessage.warning('Please select a user');
      return;
    }else if(userId < 2){
      ElMessage.warning('Please enter valid user ID');
      return;
    }
    try{
      isAssigning.value = true;
      await store.dispatch('units/updateUnit' , {id:unitId , user_id:userId});
      ElMessage.success('Unit reassigned successfully');
      // Refresh the units list
      isLoading.value = true;
      await store.dispatch('units/fetchUnits', page.value);
      units.value = store.getters['units/getUnits'];
      
    } catch (error) {
      ElMessage.error('Reassignment failed');
    } finally {
      isAssigning.value = false;
      isLoading.value = false;
      selectedUser.value = null;
    }
  }

  const handleTogglePopover = (filterKey) => {
    for (const key in filtersKeys.value) {
      if (key !== filterKey) {
        filtersKeys.value[key].isFilter = false;
      }
    }
  };
  const handleCanclePopover = (filterKey) => {
    filter_model[filterKey] = null;
  }
  // Method to open WhatsApp with the selected number and message
  const openWhatsApp = (  cellValue , unit) => {
    message.value = `*Hi, This is TAP Egypt resale & rent mobile application (operations team)*
    kindly please confirm your below attached unit details ( `+ formatPrice(unit.down_payment) +` Downpayment including 2.5% commission, `+ formatPrice(unit.price) +` total price, `+ unit.size +`m BUA, `+ unit.bedrooms + ` Beds, `+ unit.bathrooms +` Baths at `+ unit.location+`.)`;

  const url = `https://wa.me/${cellValue}?text=${encodeURIComponent(message.value)}`;
    window.open(url, '_blank');  // Opens WhatsApp in a new tab or app
  };
  const openEditForm = (row) => {
    //get backup of row
    Edited_model.value = {...units.value.data[row]} ;
    Edited_model.value.services = [];
    if (units.value.data[row].services) {
      units.value.data[row].services.forEach((serv) => {
        const matchingService = lists.value.services.find(
          (adminSer) => serv.name === adminSer.name
        );
        if (matchingService) {
          Edited_model.value.services.push(matchingService.id);
        }
      });
    }
    //close all forms and open only selected row
    units.value.data.map(unit => unit.is_edit_active = false);
    units.value.data[row].is_edit_active = true;

  }
  const closeEdit = (row) => {
    ElMessageBox.confirm(
    'You have unsaved changes, save and proceed?',
    'Confirm',
    {
      distinguishCancelAndClose: true,
      confirmButtonText: 'Discard Changes',
      cancelButtonText: 'Cancel',
    }
  )
    .then(() => {
      Edited_model.value = {};
      units.value.data[row].is_edit_active = false;
      ElMessage({
        type: 'info',
        message:'Changes Discribed',
      })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: 'Canceld.',
      })
    })
    
  }
  const handleDrawerClose = () => {
    ElMessageBox.confirm('Are you sure you want to close this?')
    .then(() => {
      EditForm.value = false;
    })
    .catch(() => {
      // catch error
    })
  }
  onMounted(async () => {
    isLoading.value = true;
    const authRole = store.getters['auth/getUserRole'] ; 
    if(authRole == 'Admin'){
      
    }
    if(userId.value){
      await store.dispatch('units/fetchUnits' , page.value);
      await store.dispatch('units/getUserUnits' , userId.value);
    }else{
      await store.dispatch('units/fetchUnits' , page.value);
    }
    lists.value = store.getters['units/getLists'];
    
    units.value = store.getters['units/getUnits'];
    isLoading.value = false;
  });
  const formatPrice = (cellValue) => {
    return numeral(cellValue).format('$0,0'); // Formats as currency
  };
  const formatDate = (row, column, cellValue) => {
    return dayjs(cellValue).format('YYYY-MM-DD'); // Formats date as YYYY-MM-DD
  };
  const paginationChanged = async (value) => {
    page.value= value;
    const pageno = page.value;
    isLoading.value = true;
    isDisabled.value = true;
    const svalue = searchValue.value;
    if(svalue){
      await store.dispatch('units/searchUnit' , { value:svalue , page:pageno});
    }else if(isUnitsFilter.value){
      await store.dispatch('units/filter' , {form:filter_model , page:page.value});
    }else if(router.currentRoute.value.params.userId){
      await store.dispatch('units/getUserUnits' , userId.value);
    }
    else{
      await store.dispatch('units/fetchUnits' , pageno);
    }
    units.value = store.getters['units/getUnits'];
    isDisabled.value = false;
    isLoading.value = false;
  };
  const deleteUnit = async (id) => {
    ElMessageBox.confirm(
      'Are you sure delete the unit. Continue?',
      'Warning',
      {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    )
      .then( async () => {
        isLoading.value = true;
        await store.dispatch('units/deleteUnit' , id);
        ElMessage({
          type: 'success',
          message: 'Delete successfull',
        })
        units.value = store.getters['units/getUnits'];
        isLoading.value = false;
      })
      .catch(() => {
        ElMessage({
          type: 'info',
          message: 'Delete canceled',
        })
      })
  };
  
  const EditUnit = async (index) => {
    
    isLoading.value = true;
    Edited_model.value.down_payment = numeral(Edited_model.value.down_payment).format('0');
    Edited_model.value.price = numeral(Edited_model.value.price).format('0');
    Edited_model.value.quarter_installment = numeral(Edited_model.value.quarter_installment).format('0');
    if(Edited_model.value.developer_id){
      const developerName = lists.value.developers.filter(dev => dev.id == Edited_model.value.developer_id)[0].name;
      const projectName = lists.value.projects.filter(proj => proj.id == Edited_model.value.project_id)[0].name;
      Edited_model.value.name = developerName + " - " + projectName;
      
    }else{
      Edited_model.value.name = Edited_model.value.finishing + " " + Edited_model.value.type + " at " + Edited_model.value.location ;
    }
    await store.dispatch('units/updateUnit' , Edited_model.value);
    units.value = store.getters['units/getUnits'];
    //units.value.data[index] = Edited_model.value;
    units.value.data[index].is_edit_active = false;
    isLoading.value = false;

  };
  const showUnit = (index) => {
    units.value.data[index].is_unit_show = true;
  };
  const handleUnitClose = (index) => {
    units.value.data[index].is_unit_show = false;
  };
  const addImageToList = (file,fileList)=> {
    AddUnitForm.images = fileList.map(item => item.raw);
    console.log(AddUnitForm);
  }
  const appendServices = (services) => {

    AddUnitForm.services = services;
    console.log(AddUnitForm.services);
  }
  const openAddForm = () => {
    // get copy of unit object
    addModel.value = {...units.value.data[0] , images : []};
    // remove un required atrributes to submit from the object
    delete addModel.value.id;
    delete addModel.value.photos;
    delete addModel.value.user;
    // empty copied object
    for (const key in addModel.value) {
      addModel.value[key] = null;
    }
    addModel.value.images = [];

    
    isAdd.value = true;
  };
  const handleAddUnitClose = () => {
    ElMessageBox.confirm(
      'You have unsaved changes, save and proceed?',
      'Confirm',
      {
        distinguishCancelAndClose: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Discard Changes',
      }
    )
    .then(() => {
      console.log(addModel.value);
      isAdd.value = false;
      resetForm();
      ElMessage({
        type: 'info',
        message: 'Changes Discribed',
      })
    })
    .catch(() => {
      
      ElMessage({
        type: 'info',
        message:'Canceld',
      })
    })
    
  };
  const resetForm = () => {
    const form = ruleFormRef.value; // Access the form instance
    if (!form) return;

    // Reset the form fields
    form.resetFields();
  };
  // Handle submit to trigger the upload
  const handleAddSubmit = async () => {
  const form = ruleFormRef.value; // Access the form instance
  if (!form) return;
      // Validate the form
      await form.validate(async (valid, fields) => {
        if (valid) {
          try {
            isAddFormLoading.value = true;

            // Format numeric fields before sending to the API
            if(AddUnitForm.developer_id){
              const developerName = lists.value.developers.filter(dev => dev.id == AddUnitForm.developer_id)[0].name;
              const projectName = lists.value.projects.filter(proj => proj.id == AddUnitForm.project_id)[0].name;
              AddUnitForm.name = developerName + " - " + projectName;
              
            }else{
              AddUnitForm.name = AddUnitForm.finishing + " " + AddUnitForm.type + " at " + AddUnitForm.location ;
            }
            AddUnitForm.down_payment = numeral(AddUnitForm.down_payment).format('0');
            AddUnitForm.price = numeral(AddUnitForm.price).format('0');
            AddUnitForm.quarter_installment = numeral(AddUnitForm.quarter_installment).format('0');
            AddUnitForm.city = AddUnitForm.location;

            // Create a FormData object for submission
            const formData = new FormData();

            // Append all form fields (except 'images') to the FormData object
            Object.keys(AddUnitForm).forEach((key) => {
              if (key !== 'images' && key !== 'services') {
                formData.append(key, AddUnitForm[key]);
              }
            });
            if(AddUnitForm.services && AddUnitForm.services.length > 0){
              AddUnitForm.services.forEach((service) => {
                formData.append('services[]',service);
              });
            }
            // Append images to the FormData object (if any images are selected)
            if (AddUnitForm.images && AddUnitForm.images.length > 0) {
              AddUnitForm.images.forEach((image) => {
                formData.append('images[]', image); // 'images[]' is the key expected by the backend
              });
            } else {
              console.log('No images selected');
            }

            // Send the form data to the store's action
            await store.dispatch('units/addNewUnit', formData);
            resetForm();
            uploadRef.value.clearFiles();
            
            // Refresh the units list to include the newly created unit
            await store.dispatch('units/fetchUnits', page.value || 1);
            units.value = store.getters['units/getUnits'];
            
            isAdd.value = false;
            ElMessage({
              type: 'success',
              message: 'Unit is Added Successfully',
            })
            
          } catch (error) {
            ElMessage({
              type: 'error',
              message: 'Something Went Wrong ...',
            })
          } finally {
            isAddFormLoading.value = false;
          }
        } else {
          console.log('Form is invalid:', fields);
        }
      });
  };
  // Before uploading: Validate file size/type (optional)
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    const isLt2M = file.size / 1024 / 1024 < 2;  // Max size: 2MB

    if (!isImage) {
      this.$message.error('You can only upload image files!');
    }
    if (!isLt2M) {
      this.$message.error('Image must smaller than 2MB!');
    }

    return isImage && isLt2M;
  };

  const openSearch = () => {
    isSearch.value = true;
  }
  const developerProjects =  computed(() => {
    const devId = AddUnitForm.developer_id;
    const filterDevId = filter_model.developer_id;
    if(filterDevId){
      return lists.value.projects.filter(project => project.developer_id == filterDevId);
    }
    if(devId){
      return lists.value.projects.filter(project => project.developer_id == devId);
    }else{
      return lists.value.projects;
    }
  });
  const projectDeveloper =  computed(() => {
    const projId = AddUnitForm.project_id;
    const filterProjId = filter_model.project_id;

    if(filterProjId){
      const devId = lists.value.projects.filter(proj => proj.id == filterProjId)[0].developer_id
      return lists.value.developers.filter(dev => dev.id == devId);
    }
    if(projId){
      const devId = lists.value.projects.filter(proj => proj.id == projId)[0].developer_id
      return lists.value.developers.filter(dev => dev.id == devId);
    }else{
      return lists.value.developers;
    }
  });
  const handlePictureCardPreview = (uploadFile) => {
    console.log(uploadFile);
    dialogImageUrl.value = uploadFile.url
    dialogVisible.value = true
  }
  const searchUnit = async () => {
    if(searchValue.value && searchValue.value != " " ){
      isLoading.value = true;
      const value = searchValue.value;
      const pageno = page.value;
      await store.dispatch('units/searchUnit' , { value:value , page:pageno})
      units.value = store.getters['units/getUnits'];
      isLoading.value = false;
    }
  }
  const refreshUnits = async () => {
    
    if(router.currentRoute.value.params.userId){
      router.push({ name: 'units'});
    }else{
      page.value = 1;

      Object.keys(filter_model).forEach(key => {
        filter_model[key] = null; // استخدام $set لضمان التفاعل مع Vue
      });
      isLoading.value = true;
      isUnitsFilter.value = false;
      searchValue.value = '';
      await store.dispatch('units/fetchUnits' , page.value);
      units.value = store.getters['units/getUnits'];
      isLoading.value = false;
    }
    
  };
  const handleApplyFilter = async (filterKey) => {
      page.value = 1;
      
      if (filter_model.updated_at && filter_model.updated_at.length === 2) {
        const [start, end] = filter_model.updated_at;
        const timezoneOffset = start.getTimezoneOffset() * 60000;
        // Convert to UTC and set to start of the day (midnight UTC)
        filter_model.updated_at_start = new Date(new Date(start).setHours(0, 0, 0, 0) - timezoneOffset);
        
        // Convert to UTC and set to end of the day (23:59:59.999 UTC)
        filter_model.updated_at_end = new Date(new Date(end).setHours(23, 59, 59, 999) - timezoneOffset);

        // Clear the original 'updated_at' field
        filter_model.updated_at = null;
      }
      
      // set updated at range date with custome formate to avoid backend issue

      /* if(filter_model.updated_at){

        filter_model.updated_at_start = filter_model.updated_at[0];
        filter_model.updated_at_end = filter_model.updated_at[1]; 
        filter_model.updated_at = null;
      } */
      // Handling 'created_at' filter
      if (filter_model.created_at && filter_model.created_at.length === 2) {
        const [start, end] = filter_model.created_at;
        const timezoneOffset = start.getTimezoneOffset() * 60000;
        // Convert to UTC and set to start of the day (midnight UTC)
        filter_model.created_at_start = new Date(new Date(start).setHours(0, 0, 0, 0) - timezoneOffset);

        // Convert to UTC and set to end of the day (23:59:59.999 UTC)
        filter_model.created_at_end = new Date(new Date(end).setHours(23, 59, 59, 999) - timezoneOffset);

        // Clear the original 'created_at' field
        filter_model.created_at = null;
      }
      /* if(filter_model.created_at){
        filter_model.created_at_start = filter_model.created_at[0];
        filter_model.created_at_end = filter_model.created_at[1]; 
        filter_model.created_at = null;
      } */



      searchValue.value = '';
      isSearch.value = false;
      isUnitsFilter.value = true;
      isLoading.value = true;
      await store.dispatch('units/filter' , {form:filter_model , page:page.value});
      units.value = store.getters['units/getUnits'];
      isLoading.value = false;
    
  };

  const normalizeExportUnits = (response) => {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (response.message && !response.data) return [];

    if (Array.isArray(response.data)) return response.data;
    if (Array.isArray(response.units)) return response.units;
    if (Array.isArray(response.data?.units)) return response.data.units;
    if (Array.isArray(response.data?.data)) return response.data.data;

    return [];
  };

  const getUnitExportValue = (item, column, apiAttribute) => {
    switch (column) {
      case 'Developer + Project':
        return item.name || [item.developer_name, item.project_name].filter(Boolean).join(' - ');
      case 'Sales name':
        return item.username || (item.user
          ? `${item.user.first_name || ''} ${item.user.last_name || ''}`.trim()
          : '');
      case 'Sales number':
        return item.user_phone || item.user?.phone || '';
      case 'User Type':
        return item.user_typ || item.user?.account_type || '';
      default:
        break;
    }

    if (apiAttribute.includes('.')) {
      const keys = apiAttribute.split('.');
      return keys.reduce((acc, key) => acc?.[key], item);
    }

    let value = item[apiAttribute];
    if (['price', 'down_payment', 'quarter_installment'].includes(apiAttribute) && typeof value === 'number') {
      value = formatNumberWithCommas(value);
    }
    return value;
  };

  const exportToExcel = async () => {
    isExport.value = true;

    try {
      const data = await fetchDataToExcel();

      if (!data.length) {
        ElMessage.warning('No units available to export.');
        return;
      }

      const attributeMapping = {
        'ID': 'id',
        'Developer + Project': 'name',
        'Description': 'description',
        'Location': 'location',
        'Built up area': 'size',
        'Bedrooms': 'bedrooms',
        'Bathrooms': 'bathrooms',
        'Category': 'category',
        'Type': 'type',
        'Total Price': 'price',
        'Level': 'level',
        'State': 'state',
        'services': 'services',
        'Timestamp': 'created_at',
        'Updated at': 'updated_at',
        'Downpayment': 'down_payment',
        'Installments': 'quarter_installment',
        'Finishing': 'finishing',
        'Delivery Date': 'delivery_date',
        'City': 'city',
        'land': 'land',
        'Sales name': 'username',
        'Sales number': 'user_phone',
        'Client name': 'clientName',
        'Client number': 'clientNumber',
        'Notes': 'Notes',
        'User Type': 'user_typ',
      };

      const columnOrder = [
        'Timestamp', 'Updated at', 'Client name', 'Client number', 'User Type', 'Sales name', 'Sales number',
        'ID', 'Developer + Project', 'Type', 'Built up area', 'land', 'Bedrooms', 'Bathrooms',
        'Downpayment', 'Installments', 'Total Price', 'Finishing', 'Location', 'Delivery Date', 'Description', 'Notes',
      ];

      const filteredData = data.map(item => {
        const filteredItem = {};
        columnOrder.forEach(attr => {
          const apiAttribute = attributeMapping[attr];
          if (apiAttribute) {
            filteredItem[attr] = getUnitExportValue(item, attr, apiAttribute);
          }
        });
        return filteredItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const currentDate = new Date().toISOString().split('T')[0];
      const fileName = `${currentDate}_units.xlsx`;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error('Export failed:', error);
      ElMessage.error('Failed to export units. Please try again.');
    } finally {
      isExport.value = false;
    }
  };

  const fetchDataToExcel = async () => {
    try {
      const value = searchValue.value?.trim();

      if (value) {
        return await fetchAllSearchUnits(value);
      }

      if (isUnitsFilter.value) {
        return await fetchAllFilteredUnits(filter_model);
      }

      const routeUserId = router.currentRoute.value.params.userId;
      if (routeUserId) {
        return await fetchAllUserUnits(routeUserId);
      }

      const response = await fetchExportUnits();
      return normalizeExportUnits(response);
    } catch (error) {
      console.error('Error fetching export data:', error);
      return [];
    }
  };

  const formatNumberWithCommas = (number) => {
    return new Intl.NumberFormat().format(number);
  };

  const AddOfferImage = (file,fileList)=> {
      Edited_model.value.offer_photo = file.raw;
      alert('offer uploaded');
  }
  return{
    isLaterThanOneMonth,
    AddOfferImage,
    exportToExcel,
    fetchDataToExcel,
    formatNumberWithCommas,
    isAssigning,
    selectedUser,
    isExport,
    userId,
    isUnitsFilter,
    router,
    filtersKeys,
    filter_model,
    uploadRef,
    shortcuts,
    AddUnitForm,
    units,
    page,
    isLoading,
    types,
    EditForm,
    lists,
    dialogImageUrl,
    delevery_dates,
    categories,
    states,
    licenses,
    isSearch,
    recommended,
    isAddFormLoading,
    isAdd,
    rules,
    addModel,
    imagesList,
    searchValue,
    switchUnitToUser,
    dialogVisible,
    formSize,
    ruleFormRef,
    ArrowRight,
    CaretBottom,
    CaretTop,
    Delete,
    Edit,
    Warning,
    View,
    Check,
    Close,
    paginationChanged,
    handleDrawerClose,
    isDisabled,
    EditUnit,
    formatPrice,
    formatDate,
    openWhatsApp,
    deleteUnit,
    openEditForm,
    closeEdit,
    Edited_model,
    tableRowClassName,
    showUnit,
    handleUnitClose,
    openAddForm,
    handleAddUnitClose,
    store,
    handleAddSubmit,
    handlePictureCardPreview,
    developerProjects,
    projectDeveloper,
    beforeUpload,
    openSearch,
    addImageToList,
    resetForm,
    appendServices,
    searchUnit,
    refreshUnits,
    handleTogglePopover,
    handleApplyFilter,
    handleCanclePopover,
  }
}
}
</script>


<style lang="scss">
@import '../assets/styles/table.scss';

.el-table .danger-row {
    --el-table-tr-bg-color: rgba(248, 126, 126, 0.699) !important;
}
</style>


// add / edit drawers style 
<style lang="scss">
.el-drawer{
  ::-webkit-scrollbar {
    width: 4px;
    transition: 0.2s ease-in-out;
  }
  /* ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    transition: 0.2s ease-in-out;
  }
  &:hover{
    ::-webkit-scrollbar-thumb {
      transition: 0.2s ease-in-out;
      background: #034750;
    }
  } */
}
.add-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 43% !important;
    }
  }
}
.show-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      .el-drawer__body {
        margin-top: 50px;
      }
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer__body {
        margin-top: 0px;
      }
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 30% !important;
    }
  }
}
.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-list .el-upload-list__item {
  cursor: move;
}
.el-carousel__item{
  background-color: #dfdfdf;
  img{
    width: 100%;
    height: 100%;
  }
}
.details-list{
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  li{
    display: flex;
  }
}
.user-info-card{
  display: flex;
  margin: 15px 0px;
  padding: 8px 0px;
  
  transition: 0.2s ease-in-out;
  &:hover{
    //box-shadow: 0px 0px 4px -2px #6d6d6d;
    border-radius: 5px;
    overflow: hidden;
    padding-left: 5px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    .user-info{
      span{
        transition: 0.2s ease-in-out;
        color: rgb(0, 68, 88);
      }
    }
  }
  .user-info{
    display: flex;
    gap: 10px;
    span{
      font-size: 13px;
      transition: 0.2s ease-in-out;
      p{
        font-weight: bold;
        margin: 0;
      }
    }
  }
}
</style>

// statistics Style
<style scoped>
.statistcs-container{
  margin-bottom: 50px;
}
:global(h2#card-usage ~ .example .example-showcase) {
  background-color: var(--el-fill-color) !important;
}

.el-statistic {
  --el-statistic-content-font-size: 28px;
}

.statistic-card {
  height: 100%;
  padding: 15px;
  border-radius: 10px;
  background-color: #d8e5e78f;
  /* border: solid 1px #f1f1f1; */
}

.statistic-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  color: var(--el-text-color-regular);
  margin-top: 16px;
}

.statistic-footer .footer-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statistic-footer .footer-item span:last-child {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

.green {
  color: var(--el-color-success);
}
.red {
  color: var(--el-color-error);
}
</style>